import { useTranslation } from 'react-i18next'

import { QA_NAME_CANCEL_BTN, QA_NAME_SAVE_BTN } from '../../../../constants/qa'
import Button from '../../../Button'

import * as styles from './ColorPickerPopoverActions.module.css'

function ColorPickerPopoverActions({ onCancel, onSave }) {
  const { t } = useTranslation()

  return (
    <div className={styles.actions}>
      <Button.Contained
        qaName={QA_NAME_SAVE_BTN}
        text={t('Modal.SaveBtnKey')}
        onClick={onSave}
      />
      <Button.Outlined
        qaName={QA_NAME_CANCEL_BTN}
        text={t('Modal.CancelBtnKey')}
        onClick={onCancel}
      />
    </div>
  )
}

export default ColorPickerPopoverActions
